import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const GET_BRANDS = gql`
  query getBrandsForSupplierIds($supplierIds: [String!]!) {
    getBrandsForSupplierIds(supplierIds: $supplierIds) {
      brands {
        supplierId
        brandName
        brandLogoUrl
        brandId
        brandRevisionId
      }
    }
  }
`;

const getBrandsQuery = async ({ variables }) => {
  try {
    const response = await query({
      query: GET_BRANDS,
      variables,
    });

    return response.data.getBrandsForSupplierIds.brands;
  } catch (error) {
    throw new Error(error);
  }
};

export default getBrandsQuery;
